export const DS_TABLE_CLASSES = {
  Root: "ds-table",
  Table: "ds-table__table",
  Cell: "ds-table__cell",
  Header: "ds-table__header",
  GroupHeader: "ds-table__group-header",
  StickyStart: "ds-table__cell--sticky-start",
  StickyEnd: "ds-table__cell--sticky-end",
  StickyEndBoundary: "ds-table__cell--sticky-end-boundary",
  Sort: "ds-table__sort",
  SortIcon: "ds-table__sort-icon",
  SortIconActive: "ds-table__sort-icon--active",
  SortIconAscending: "ds-table__sort-icon--ascending",
  RightBorder: "ds-table__cell--right-border",
  StickyHeader: "ds-table--sticky-header",
} as const;
